import { IconSize } from '../Icon';
import { RatingContainer } from './Rating.styles';
import { RatingStar, RatingStarAppearance } from './RatingStar';

type RatingProps = {
  label: string;
  value: number;
  maxValue?: number;
  starSize?: IconSize;
  className?: string;
};

const Rating = ({
  label,
  value,
  maxValue = 5,
  starSize,
  className,
}: RatingProps) => {
  if (!value) {
    return null;
  }

  const stars = new Array(maxValue).fill(null).map((_, index) => index + 1);
  const halfStarsValue = Math.round(value * 2);

  return (
    <RatingContainer
      value={value}
      role="meter"
      aria-valuemin={1}
      aria-valuemax={maxValue}
      aria-valuenow={value}
      aria-label={label}
      className={className}
    >
      {stars.map(i => {
        let appearance = RatingStarAppearance.Empty;

        if (halfStarsValue >= i * 2) {
          appearance = RatingStarAppearance.Full;
        } else if (halfStarsValue >= i * 2 - 1) {
          appearance = RatingStarAppearance.Half;
        }

        return (
          <RatingStar
            key={i}
            appearence={appearance}
            aria-hidden="true"
            size={starSize}
          />
        );
      })}
    </RatingContainer>
  );
};

export { Rating };
export type { RatingProps };
